import {Box, Card, Grid} from '@primer/react-brand/esm'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {renderWithoutParagraphs} from '../../../../utils'
import type {IntroSectionProps} from '../types'
import baseStyles from '../../../../styles/base.module.css'

type Props = Pick<IntroSectionProps, 'introIconCards'> & {promoteFirstHeading?: boolean}

export function IntroIconCards({introIconCards, promoteFirstHeading = false}: Props) {
  if (!introIconCards || introIconCards.length === 0) return null

  const mediumColumnSpan = introIconCards.length === 2 ? 6 : 4

  return (
    <Box className={baseStyles.cardGridFrame}>
      <Grid className={baseStyles.gridContent}>
        {introIconCards.map((item, index) => {
          const IconComponent = getPrimerIcon(item.fields.icon)
          return (
            /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
            <Grid.Column key={item.sys.id} span={{medium: mediumColumnSpan}} className="gridColumn">
              <Box
                className={baseStyles.cardGridItem}
                padding={{narrow: 24, regular: 40}}
                paddingBlockStart={{regular: 80}}
                paddingBlockEnd={{regular: 80}}
                borderWidth="thin"
                borderColor="muted"
              >
                <Card href={item.fields.href} variant="minimal" fullWidth ctaText={item.fields.label}>
                  {IconComponent ? <Card.Icon icon={<IconComponent />} color="default" hasBackground /> : null}
                  {item.fields.eyebrow ? <Card.Label>{item.fields.eyebrow}</Card.Label> : null}
                  <Card.Heading as={index === 0 && promoteFirstHeading ? 'h2' : 'h3'} size="6">
                    {renderWithoutParagraphs(item.fields.heading)}
                    {item.fields.alt ? <span className="sr-only"> {item.fields.alt}</span> : null}
                  </Card.Heading>
                  <Card.Description>{renderWithoutParagraphs(item.fields.description)}</Card.Description>
                </Card>
              </Box>
            </Grid.Column>
          )
        })}
      </Grid>
    </Box>
  )
}
